import React from 'react';
import { Button, Text } from '@fragments';
import { IconArrowUpRight, IconSparkles } from '@tabler/icons-react';
import TopicPreview from '../TopicPreview';
import { STUDIO_TRENDING } from '../../../../enums/routes';
import './styles.scss';

// Compact (chat) mode offers refine prompts; the home prompt offers trending topics. The
// heading always leads to the trending gallery; the topics themselves are Pro's
// (`features.trending_topics`), so without the plan the heading stands alone.
export default function ComposerSuggestions({ studio: s, compact, showTopics, setValue }) {
  const { t } = s;
  const topics = showTopics && s.features.trending_topics ? s.topics.slice(0, 4) : [];
  // The refine prompts come with the script or the art (contract 2.4.0; arts 2.7.0 proposal);
  // a script written before them falls back to the fixed three.
  const fallback = s.art?.enabled ? 'artRefine' : 'refine';
  const written = s.art?.enabled ? s.art.latest?.suggestions : s.revision?.suggestions;
  const refine = written?.length ? written
    : [1,2,3].map(n => ({ label: t(`${fallback}Suggestion${n}`), prompt: t(`${fallback}Prompt${n}`) }));
  return <div className="studio-topics-preview"><div className="studio-composer__heading">
    {compact && <Text.caption weight={400} className="studio-ai-heading" left={<IconSparkles aria-hidden="true" />}>{t('refineSuggestions')}</Text.caption>}
    {showTopics && <Button className="studio-ai-trigger studio-plain-control" variant="rounded" size="small" color="overlay" endIcon={<IconArrowUpRight />} onClick={() => s.navigate(STUDIO_TRENDING)}><Text.caption className="studio-ai-heading" left={<IconSparkles aria-hidden="true" />}>{t('inspiration')}</Text.caption></Button>}
  </div>
    {compact ? <div className="studio-topic-chips">{refine.map(({ label, prompt }) => <Button key={label} size="small" color="overlay" variant="rounded" onClick={() => setValue(prompt)}>{label}</Button>)}</div>
      : topics.length > 0 && <div className="studio-topic-chips is-cards">{topics.map(topic => <TopicPreview key={topic.id} topic={topic} studio={s} />)}</div>}
  </div>;
}
